import { useCallback, useEffect, useState } from 'react';
import {
  getAdminCommandCenterReadModel,
  type AdminCommandCenterReadModel,
} from '../services/adminCommandCenterService';

export interface UseAdminCommandCenterState {
  data: AdminCommandCenterReadModel | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export const useAdminCommandCenter = (): UseAdminCommandCenterState => {
  const [data, setData] = useState<AdminCommandCenterReadModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const readModel = await getAdminCommandCenterReadModel();
      setData(readModel);
    } catch (readError) {
      console.error('[useAdminCommandCenter] Dashboard read failed:', readError);
      setError('Nie udalo sie odczytac centrum operacyjnego admina.');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    data,
    loading,
    error,
    refresh,
  };
};
